<template>
  <nav :class="['sidebar', { recolhida }]" aria-label="Menu principal">
    <div class="marca">
      <img src="@/assets/loginimg.png" alt="" class="marca-logo">
      <span v-if="!recolhida" class="marca-nome">Clockin</span>
      <button class="btn-recolher" @click="recolhida = !recolhida" :title="recolhida ? 'Expandir menu' : 'Recolher menu'">
        <i :class="recolhida ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
      </button>
    </div>

    <div class="menu">
      <template v-for="(grupo, gi) in menusPermitidos" :key="gi">
        <div v-if="grupo.titulo && !recolhida" class="grupo-titulo">{{ grupo.titulo }}</div>
        <div v-else-if="grupo.titulo" class="grupo-divisor"></div>
        <router-link v-for="item in grupo.itens" :key="item.link" :to="item.link" class="item"
                     :class="{ ativo: ativo(item.link) }" :title="item.nome">
          <i :class="item.icone"></i>
          <span v-if="!recolhida">{{ item.nome }}</span>
        </router-link>
      </template>
    </div>

    <a v-if="!recolhida" href="/ponto-itinerante" target="_blank" class="relogio-link">
      <i class="bi bi-tablet"></i>
      <span>Abrir relógio itinerante</span>
    </a>
  </nav>
</template>

<script>
import util from '@/util'

export default {
  name: 'sider',
  data() {
    return {
      recolhida: window.innerWidth < 992,
      menus: [
        { titulo: '', itens: [
          { nome: 'Painel', link: '/', icone: 'bi bi-grid-1x2' },
        ]},
        { titulo: 'Ponto', itens: [
          { nome: 'Registros de ponto', link: '/registrosdeponto', icone: 'bi bi-fingerprint', perm: 'registros' },
          { nome: 'Espelho de ponto', link: '/relespelhoponto', icone: 'bi bi-calendar3', perm: 'espelho' },
          { nome: 'Escalas e exceções', link: '/escalas', icone: 'bi bi-calendar-week', perm: 'escalas' },
          { nome: 'Justificativas', link: '/justificativas', icone: 'bi bi-journal-check', perm: ['justificativas', 'justificativas_aprovar'] },
          { nome: 'Arquivos fiscais', link: '/exportar', icone: 'bi bi-file-earmark-lock', perm: 'fiscal' },
        ]},
        { titulo: 'Cadastros', itens: [
          { nome: 'Colaboradores', link: '/colaboradores', icone: 'bi bi-people', perm: 'colaboradores' },
          { nome: 'Jornadas', link: '/jornadas', icone: 'bi bi-clock-history', perm: 'jornadas' },
          { nome: 'Feriados', link: '/feriados', icone: 'bi bi-calendar-heart', perm: 'feriados' },
          { nome: 'Relógios (tablets)', link: '/terminais', icone: 'bi bi-tablet-landscape', perm: 'terminais' },
          { nome: 'Zonas', link: '/zonas', icone: 'bi bi-geo-alt', perm: 'zonas' },
          { nome: 'Grupos', link: '/grupos', icone: 'bi bi-diagram-3', perm: 'cadastros' },
          { nome: 'Subgrupos', link: '/subgrupos', icone: 'bi bi-diagram-2', perm: 'cadastros' },
          { nome: 'Funções', link: '/funcoes', icone: 'bi bi-briefcase', perm: 'cadastros' },
        ]},
        { titulo: 'Configurações', itens: [
          { nome: 'Empresas', link: '/empresas', icone: 'bi bi-building', perm: 'empresas' },
          { nome: 'Usuários', link: '/usuarios', icone: 'bi bi-person-gear', perm: 'usuarios' },
        ]},
      ],
    }
  },
  computed: {
    /** Só mostra o que o usuário pode acessar; grupos vazios somem. */
    menusPermitidos() {
      const u = this.$store.state.usuario
      return this.menus
        .map(g => ({ ...g, itens: g.itens.filter(i => !i.perm || util.pode(i.perm, u)) }))
        .filter(g => g.itens.length)
    },
  },
  methods: {
    ativo(link) {
      const atual = this.$route.path.toLowerCase()
      return link === '/' ? atual === '/' : atual.startsWith(link.toLowerCase())
    },
  },
}
</script>

<style scoped lang="scss">
.sidebar {
  width: 236px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #0f463e 0%, #13534a 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 14px 10px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  transition: width .2s ease;
}
.sidebar.recolhida { width: 68px; }
.marca { display: flex; align-items: center; gap: 10px; padding: 4px 6px 16px; }
.marca-logo { width: 34px; height: 34px; border-radius: 9px; background: #fff; padding: 2px; flex-shrink: 0; }
.marca-nome { font-weight: 700; font-size: 1.1rem; flex: 1; }
.btn-recolher { margin-left: auto; background: transparent; border: 0; color: rgba(255,255,255,.7); padding: 4px; border-radius: 6px; }
.btn-recolher:hover { color: #fff; background: rgba(255,255,255,.08); }
.recolhida .marca { flex-direction: column; gap: 8px; }
.recolhida .btn-recolher { margin-left: 0; }

.grupo-titulo { font-size: .68rem; text-transform: uppercase; letter-spacing: .08em; color: rgba(255,255,255,.5); padding: 14px 12px 6px; }
.grupo-divisor { height: 1px; background: rgba(255,255,255,.12); margin: 10px 8px; }
.item {
  display: flex; align-items: center; gap: 12px;
  color: rgba(255,255,255,.82); text-decoration: none;
  padding: 9px 12px; border-radius: 10px; font-size: .88rem; font-weight: 500;
  margin-bottom: 2px; white-space: nowrap;
}
.item i { font-size: 1.05rem; width: 20px; text-align: center; }
.item:hover { background: rgba(255,255,255,.08); color: #fff; }
.item.ativo { background: rgba(255,255,255,.14); color: #fff; box-shadow: inset 3px 0 0 var(--ck-acento); }
.recolhida .item { justify-content: center; padding: 10px; }

.relogio-link {
  margin-top: auto; display: flex; align-items: center; gap: 10px;
  background: rgba(242, 177, 52, .14); color: #ffd98a; text-decoration: none;
  border-radius: 10px; padding: 10px 12px; font-size: .82rem; font-weight: 600;
}
.relogio-link:hover { background: rgba(242, 177, 52, .22); color: #ffe6b0; }
</style>
